import { animate, state, style, transition, trigger } from '@angular/animations';

export const SwitchAnimations = [
    trigger('statusChange', [
        state('false', style({ transform: 'translateX({{dxMovement}}px)' }), { params: { dxMovement: 0 } }),
        state('true', style({ transform: 'translateX(-2)' })),
        transition('true <=> false', animate('200ms'))
    ])
];
